import { cilTrash } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BackButton from "components/buttons/BackButton";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import Dummy from "components/Dummy";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import P from "components/P";
import Container from "layouts/container/Container";
import FixedFooter from "layouts/container/FixedFooter";
import FixedHeader from "layouts/container/FIxedHeader";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import CircleWrapper from "layouts/wrapper/CircleWrapper";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ShoppingProcessType } from "shared/constants/constants";
import style from "./ShoppingLayout.module.css";
import addCart from "resources/img/icons/mypage/addCart.svg";
import order from "resources/img/icons/mypage/order.svg";
import checkMark from "resources/img/icons/mypage/checkMark.svg";

function ShoppingLayout() {
    const { isMobile } = useContext(BrowserDetectContext);
    const [viewData, setViewData] = useState({
        title: "",
        footterButtonText: "",
        currentProcess: null,
        totalCount: 0,
        selectedCount: 0,
        priceSum: 0,
        vat: 0,
        deliveryFee: 0,
        discountSum: 0,
        totalAmount: 0,
        onDeleteSelectedProductsClick: () => { },
        onSubmitButtonClick: () => { }
    });
    const { t } = useTranslation();
    const shoppingProcesses = [
        { orderNo: ShoppingProcessType.CART, title: t("cart"), icon: addCart },
        { orderNo: ShoppingProcessType.ORDER, title: t("orderHistory"), icon: order },
        { orderNo: ShoppingProcessType.ORDER_COMPLETE, title: t("orderComplete"), icon: checkMark },
    ];

    const onDeleteSelectedProductsClick = () => {
        if (viewData && viewData.onDeleteSelectedProductsClick) {
            viewData.onDeleteSelectedProductsClick();
        }
    }

    return (
        <div className={style.container}>
            {/* {
                isMobile &&
                <>
                    <FixedHeader height={50}>
                        <div className={style.titleWrap}>
                            <Container maxWidth={1200}>
                                <HorizontalFlex height={50}>
                                    <FlexChild width={50}>
                                        <BackButton color={"black"} />
                                    </FlexChild> */}
                                    {/* <FlexChild>
                                        <Center alignItems={"flex-start"}>
                                            <Inline>
                                                <P color={"black"}>{viewData.title}</P>
                                            </Inline>
                                        </Center>
                                    </FlexChild> */}
                                    {/* <FlexChild width={20}></FlexChild>
                                </HorizontalFlex>
                            </Container>
                        </div>
                    </FixedHeader>
                </>
            } */}
            <Container backgroundColor={"white"}>
                {/* {
                    !isMobile &&
                    <Container height={110} maxWidth={1200} padding={50} borderBottom={"1px solid #ddd"}>
                        <HorizontalFlex>
                            <FlexChild>
                                <P size={25} weight={1000}>{viewData.title}</P>
                            </FlexChild>
                            <FlexChild width={"initial"}>
                                <HorizontalFlex gap={20}>
                                    {
                                        shoppingProcesses.map((process, index) => {
                                            return (
                                                <FlexChild>
                                                    <HorizontalFlex gap={20}>
                                                        <FlexChild>
                                                            <HorizontalFlex gap={10}>
                                                                <FlexChild width={"initial"}>
                                                                    <Center>
                                                                        <img src={process.icon} width={process.orderNo === viewData.currentProcess ? 25 : 20} />
                                                                    </Center>
                                                                </FlexChild>
                                                                <FlexChild width={"initial"}>
                                                                    <div style={{ width: "70px" }}>
                                                                        <Center>
                                                                            <P size={18} color={process.orderNo === viewData.currentProcess ? "black" : "#949494"} weight={process.orderNo === viewData.currentProcess ? 800 : 100}>{process.title}</P>
                                                                        </Center>
                                                                    </div>
                                                                </FlexChild>
                                                            </HorizontalFlex>
                                                        </FlexChild>
                                                        {
                                                            index < shoppingProcesses.length - 1 &&
                                                            <FlexChild width={"initial"}>
                                                                <FontAwesomeIcon icon={fas["faAngleRight"]} fontSize={15} />
                                                            </FlexChild>
                                                        }
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            );
                                        })
                                    }

                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </Container>
                } */}

                <Container maxWidth={1200} padding={isMobile ? 0 : 30} marginTop={ isMobile ? 0 : 100}>
                    <VerticalFlex height={"initial"} gap={15}>
                        <FlexChild>
                            <Dummy height={isMobile ? 0 : 30}/>
                            <div className={style.productWrap}>
                                <Outlet context={{ setViewData }} />
                            </div>
                        </FlexChild>
                        {/* {
                            !isMobile &&
                            <>
                                {
                                    viewData.currentProcess === ShoppingProcessType.CART &&
                                    <FlexChild alignItems={"flex-end"} padding={"0px 20px"} >
                                        <div className={style.deleteAllButton} onClick={onDeleteSelectedProductsClick}>
                                            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
                                                <FlexChild width={"initial"}>
                                                    <Center>
                                                        <CIcon icon={cilTrash} size="lg" />
                                                    </Center>
                                                </FlexChild>
                                                <FlexChild width={"initial"}>
                                                    <Center>
                                                        <P size={12}>{t("choice")}{t("delete")}</P>
                                                    </Center>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </div>
                                    </FlexChild>
                                }
                            </>
                        } */}
                    </VerticalFlex>
                </Container>
            </Container >

            <Dummy height={"var(--footerHeight)"} />

        </div >
    );
}

export default ShoppingLayout;